import { setAuthorization } from "../../../helpers/api_helper";
import { clearStoredAuth } from "../../../helpers/auth_storage";
import {
  getAuthSession,
  login as authLogin,
  logout as authLogout,
} from "../../../services/authService";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from "./reducer";

const resolveErrorMessage = (error: unknown): string => {
  if (typeof error === "string") {
    return error;
  }

  if (
    error &&
    typeof error === "object" &&
    "data" in error &&
    typeof (error as { data: unknown }).data === "string"
  ) {
    return (error as { data: string }).data;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Request failed";
};

export const loginUser = (user: { email: string; password: string }, history: (path: string) => void) =>
  async (dispatch: (action: unknown) => void) => {
    try {
      const response = await authLogin(user.email, user.password);

      if (
        response.success &&
        response.data &&
        "type" in response.data &&
        response.data.type === "membership_selection_required"
      ) {
        history("/select-studio");
        return;
      }

      if (
        response.success &&
        response.data &&
        "access_token" in response.data &&
        response.data.access_token
      ) {
        const session = getAuthSession();

        dispatch(loginSuccess(session));
        history("/dashboard");
        return;
      }

      dispatch(apiError({ data: response.message || "Request failed" }));
    } catch (error) {
      dispatch(apiError({ data: resolveErrorMessage(error) }));
    }
  };

export const logoutUser = () => async (dispatch: (action: unknown) => void) => {
  try {
    await authLogout();
    setAuthorization("");
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    clearStoredAuth();
    setAuthorization("");
    dispatch(logoutUserSuccess(true));
    dispatch(apiError({ data: resolveErrorMessage(error) }));
  }
};

/** Velzon demo — social login via Firebase removido (Adatis usa JWT). */
export const socialLogin = (_type: unknown, _history: (path: string) => void) =>
  async (_dispatch: (action: unknown) => void) => {
    // noop
  };

export const resetLoginFlag = () => async (dispatch: (action: unknown) => void) => {
  try {
    dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError({ data: resolveErrorMessage(error) }));
  }
};
